import styled from 'styled-components'

// Fixed header (72px) + sticky status notification bar (40px)
export const SITE_PROPOSAL_HEADER_OFFSET = '112px'

export const KbaCriteriaSummaryWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 32px;
  margin-top: ${(props) => props.marginTop ?? SITE_PROPOSAL_HEADER_OFFSET};
`

export const KbaCriteriaSummaryLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px 12px;
  max-width: 960px;
  width: 100%;
  padding: 12px 18px;
  border: 1px solid rgba(10, 161, 244, 0.18);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(10, 161, 244, 0.06) 0%, rgba(255, 255, 255, 0.95) 100%);
  box-shadow: 0 4px 14px rgba(32, 32, 32, 0.04);
  font-size: 14px;
  line-height: 20px;
`

export const KbaCriteriaSummaryLabel = styled.span`
  font-weight: 600;
  color: rgba(32, 32, 32, 0.78);
  flex-shrink: 0;
`

export const KbaCriteriaSummaryValues = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
`

export const KbaCriteriaChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(10, 161, 244, 0.28);
  background: rgba(10, 161, 244, 0.1);
  color: #0877b5;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.01em;
  white-space: nowrap;
`
